<template>
    <div>
        <b-row>
            <b-col>
                <DxTreeList
                    id="treeNeedingCosigner"
                    :ref="treeListRefKey"
                    :data-source="this.dataSource"
                    :show-borders="true"
                    :column-auto-width="false"
                    :word-wrap-enabled="true"
                    key-expr="notesid"
                    @saving="SaveOrEdit($event)"
                    class="column-view-check"
                    :height="'70vh'"
                    v-if="this.showTreeList"
                >
                    <DxEditing :allow-updating="true" mode="batch"/>
                    <DxSearchPanel :visible="true" :width="250" :placeholder="$t('Shared.Search')"/>
                    <DxSorting mode="none"/> <!-- or "multiple" | "none" -->
                    <DxToolbar>
                        <DxItem name="searchPanel" :width="250" />
                    </DxToolbar>

                    <DxColumn
                        width="30px"
                        data-field="checked"
                        data-type="boolean"
                        headerCellTemplate ="headerCellTemplateAllP"
                        css-class="headercell-view-padding"
                    />
                    <template #headerCellTemplateAllP="{ data }">
                        <DxCheckBox 
                            :value="false"
                            text=""
                            iconSize="16px"
                            @value-changed="onValueChangedCheck($event, data)"/>
                    </template>

                    <DxColumn
                        data-field="description"
                        :caption="$t('Shared.Description')"
                        :read-only="true"
                        :allow-editing="false"
                        css-class="cell-provider-align"
                    />
                </DxTreeList>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12" class="my-3">
                <div>
                    <MdButton
                        v-bind:Label="$t('Shared.Save')"
                        v-bind:Name="'btnSaveNeedingCosigner'"
                        v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                        v-on:click="treeList.saveEditData()"/>   
                </div>
                <div>
                    <MdButton
                        v-bind:Label="$t('Shared.BtnCancel')"
                        v-bind:Name="'btnCancelNeedingCosigner'"
                        v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                        v-on:click="treeList.cancelEditData()"/>   
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import UserTplService from '@/services/users.tpl.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import {
    DxTreeList,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxItem,
    DxSearchPanel,
    DxSorting
} from 'devextreme-vue/tree-list';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { EventBus } from '@/event-bus.js';

const treeListRefKey = 'ncTreeList';

export default {
    name: 'userRoleDetailNC',
    mixins: [ShowMessage, DBFunctions],

    props: {
        RolId: String,
        AccordionVisible: Boolean
    },

    components: {
        DxTreeList,
        DxColumn,
        DxSearchPanel,
        DxEditing,
        DxToolbar,
        DxItem,
        DxCheckBox,
        DxSorting
    },

    data() {
        return {
            dataSource: [],
            treeListRefKey,
            showTreeList: false
        }
    },

    computed: {
        treeList: function() {
            return this.$refs[treeListRefKey].instance;
        },
    },

    watch: {
        RolId: function () {
            if (this.showTreeList) {
                this.getNeedingCosigner();
            }
        },

        AccordionVisible: function(newValue) {
            if (newValue && !this.showTreeList) {
                this.showTreeList = true;
                this.getNeedingCosigner();
            }
            if (!newValue) {
                let changes = this.treeList.option("editing.changes");
                if (changes.length != 0) {
                    this.showMessage(this.$tc('Msg.Warning'),this.$t('userRoleDetails.LeavingWithoutSaving', {name: this.$t('userRoleDetails.CosignerNeeding').toUpperCase()}),"warning");
                }
            }
        }
    },

    methods: {
        async getNeedingCosigner() {
            this.dataSource = [];
            EventBus.$emit('ShowWeel', true);
            await UserTplService.getNeedingCosigner(this.RolId)
                        .then((response) => {
                            if(response.data) {
                                this.dataSource = response.data; 
                            }
                            EventBus.$emit('ShowWeel', false);
                        })
                        .catch((error) => {
                            this.showResponseErrorMessage(error);
                            EventBus.$emit('ShowWeel', false);
                        })
        },

        onValueChangedCheck(e, d) {
            let changes = this.treeList.option("editing.changes");
            let dataField =  d.column.dataField

            this.treeList.forEachNode((node) => {
                let curNode = changes.find((el) => {
                    return node.key === el.key;
                });
                if (curNode) {
                    curNode.data[dataField] = e.value;
                } else {
                    changes.push({
                        key: node.key,
                        data: { [dataField] : e.value },
                        type: "update",
                    });
                }
            });
            this.treeList.option("editing.changes", changes);
        },

        SaveOrEdit(e) {
            EventBus.$emit('ShowWeel', true);
            setTimeout(() => {
                const params = {
                    noteDataList: e.component.getDataSource().store()._array.map(item => ({
                        noteId : item.notesid,
                        checked : item.checked
                    })),
                };
                
                UserTplService.updateNeedingCosigner(this.RolId, params)
                            .then((response) => {
                                if (response.status == '200') {
                                    setTimeout(() =>
                                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                            title: this.$t('Msg.Success'),
                                            autoHideDelay: 5000,
                                            variant: "success"
                                        })
                                    , 5);
                                }
                                EventBus.$emit('ShowWeel', false);
                            })
                            .catch((error) => {
                                this.showResponseErrorMessage(error);
                                EventBus.$emit('ShowWeel', false);
                            })
            }, 100); 
        }
    }
}
</script>

<style>
#tasks {
    max-height: 540px;
}

#tasks .dx-treelist-rowsview td {
    vertical-align: middle;
}

.dx-data-row .cell-provider-align {
    vertical-align: middle !important;
    padding-left: 10px !important;
}

.dx-data-row .headercell-view-padding {
    padding: 5px 5px 7px 5px !important;
}

.column-view-check .dx-treelist-rowsview .dx-treelist-empty-space {
    width: 0px !important;
}
</style>